import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import { useTable, useRowSelect, useSortBy } from "react-table";
import TripAndCharge from "components/trip_and_charge_component/TripAndCharge";
import { postRequest, deleteRequest } from "services/axiosBaseClient";
import styles from "../mychargers.module.scss";
import cn from "classnames";
import BatteryProgress from "../echarts/BatteryProgress";
// import { useDispatch } from 'react-redux';
import { addFleetId } from "redux/chargerTableSlice";

const Styles = styled.div`
  padding: 0rem;
  overflow: auto;
  height: 49.5vh;
  @media (max-width: 1680px) {
    height: 47vh;
  }
  @media (max-width: 1440px) {
    height: 39vh;
  }
  @media (max-width: 1368px) {
    height: 37vh;
  }

  td:nth-child(5) {
    width: 115px;
  }
  th:nth-child(3) {
    //  text-align:center;
  }
  th:nth-child(9) {
    // text-align:center;
  }
  th:nth-child(10) {
    // text-align:center;
  }
  table thead {
    position: sticky;
    top: 0px;
    margin: 0 0 0 0;
  }

  td:nth-child(6) {
    width: 165px;
    color: #000000;
  }
  td:nth-child(7) {
    //  text-align:center;
    width: 150px;
  }
  td:nth-child(8) {
    // text-align:center;
    width: 150px;
  }
  td:nth-child(9) {
    // text-align:center;
    color: #000000;
    // text-align: center;
  }
  th:nth-child(11) {
    //  float:right;
    width: 150px;
  }
  td:nth-child(10) {
    // text-align:center;
    color: #000000;
  }
  td:nth-child(11) {
    // text-align:center;
    color: #000000;
  }
  th:nth-child(12) {
    width: 80px;
    padding-right: 0px;
  }
  th:nth-child(3) > div {
    text-align: center;
    justify-content: center;
  }
  th:nth-child(9) > div {
    text-align: center;
    justify-content: center;
  }
  table {
    border-spacing: 0;
    border: 0px solid black;
    width: 100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    .textColor {
      color: #5696ae;
    }
    tr:nth-child(odd) > td {
      background-color: #f2f2f2;
      opacity: 1;
    }
    th {
      font: normal normal bold 15px/19px Montserrat;
      color: #000000;
      min-width: 100px;
      padding: 5px 8px;
    }
    th:nth-child(1) {
      min-width: 40px;
      // padding-left: 10px;
    }
    td {
      margin: 0;
      border-bottom: 0px solid black;
      border-right: 0px solid black;
      font: normal normal 15px/19px Montserrat;
      // height: 76px;
      padding: 0px 8px;
      /* The secret sauce */
      /* Each cell should grow equally */
      // width: 1%;
      /* But "collapsed" cells should be as small as possible */
      &.collapse {
        width: 0.0000000001%;
      }
      .charging {
        color: #6a9930;
      }
      .Charging {
        color: #6a9930;
      }
      .CHARGING {
        color: #6a9930;
      }
      .UP {
        color: #6a9930;
      }
      .discharging {
        color: #5696ad;
      }
      .Discharging {
        color: #5696ad;
      }
      .DISCHARGING {
        color: #5696ad;
      }
      .PLUGGED {
        color: #e5972d;
      }
      .Plugged {
        color: #e5972d;
      }
      .plugged {
        color: #e5972d;
      }
      .AVAILABLE {
        color: #b472b5;
      }
      .Available {
        color: #b472b5;
      }
      .available {
        color: #b472b5;
      }

      .Unplugged {
        color: #b472b5;
      }
      .unplugged {
        color: #b472b5;
      }
      .UNPLUGGED {
        color: #b472b5;
      }
      .Error {
        color: #a23b3e;
      }
      .ERROR {
        color: #a23b3e;
      }
      .error {
        color: #a23b3e;
      }
      .DOWN {
        color: #a23b3e;
      }
      .down {
        width: 36px;
        padding-left: 5px;
      }
      .Alert {
        color: #a23b3e;
      }
      .alert {
        color: #a23b3e;
      }
      .ALERT {
        color: #a23b3e;
      }
      .pluggedError {
        width: 36px;
        // // margin: 0 auto;
        // padding-left: 10px;
      }
      .PLUGGEDERROR {
        width: 36px;
        // // margin: 0 auto;
        // padding-left: 10px;
      }
      .busError {
        width: 36px;
        // // margin: 0 auto;
        // padding-left: 10px;
      }
      .BUSERROR {
        width: 36px;
        // // margin: 0 auto;
        // padding-left: 10px;
      }
      .OFFLINE {
        color: #353535;
      }
    }
    @media screen and (max-width: 1399px) {
      th {
        font: normal normal bold 13px/15px Montserrat;
        padding: 0px 5px;
      }
      td {
        font: normal normal 13px/15px Montserrat;
        padding: 0px 5px;
      }
    }
    .flex-th {
      display: flex;
      justify-content: start;
      align-items: center;
    }
  }
`;
var rowdataObj;
var checkCount = -1;
let rowID;
let chargerId;
let chargerTableId;
var vehicleID;
var TripCharge;
var downArrow = (
  <img
    src={require("assets/sortAscending_down.svg").default}
    className={cn(styles.marginLeft)}
  />
);
var upArrow = (
  <img
    src={require("assets/sortAscending_up.svg").default}
    className={cn(styles.marginLeft)}
  />
);
const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    if ({ ...rest }.checked === true || indeterminate === true) {
      checkCount = checkCount + 1;
    } else {
      checkCount = 0;
    }

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <label className={cn(styles.container)}>
          <input type="checkbox" ref={resolvedRef} {...rest} />
          <span className={cn(styles.checkmark)}></span>
        </label>
      </>
    );
  }
);
// console.log(checkCount)

function Table({ columns, data, checkPopUp, toggleInput }) {
  const [checkTrip, setCheckTrip] = useState(false);
  // Use the state and functions returned from useTable to build your UI
  // const dispatch = useDispatch();
  const shortingColumn = (column) => {
    setCheckTrip(column?.isSortedDesc);
    if (
      column?.id !== "selection" &&
      column?.id !== "setChargingTime" &&
      column?.id !== "tripSchedule"
    ) {
      localStorage.setItem("fleetShorting", column?.id);
    } else {
      let selectedId = selectedFlatRows.map((item) => item.id);
      if (selectedId.length > 0) {
        localStorage.setItem("selectedId", "");
      } else {
        localStorage.setItem("selectedId", "");
      }
    }
  };

  let shortId;
  // let shortId = localStorage.getItem('fleetShorting')
  if (localStorage.getItem("fleetShorting") === null) {
    shortId = "nextTrip.date";
  } else {
    shortId = localStorage.getItem("fleetShorting");
  }
  const sortees = React.useMemo(() => [
    {
      id: shortId,
      desc:
        shortId === "nextTrip.date" && checkTrip === false
          ? true
          : checkTrip === false
          ? true
          : false,
    },
  ]);
  var resData = "";
  let localChargerID = localStorage.getItem("selectedId");

  if (
    localChargerID !== undefined &&
    localChargerID !== null &&
    localChargerID !== ""
  ) {
    if (localChargerID?.length > 0) {
      const split_string = localChargerID?.split(",");
      resData = split_string?.reduce(
        (acc, curr) => ((acc[curr] = true), acc),
        {}
      );
    } else {
      resData = "";
    }
  } else {
    resData = "";
  }
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    toggleAllRowsSelected,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      // defaultCanSort: true,
      initialState: {
        sortBy: sortees,
        selectedRowIds: resData,
      },
    },
    useSortBy,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  if (checkPopUp === true) {
    const ca = toggleAllRowsSelected;
    toggleInput(ca);
    rowdataObj = [];
  } else {
    rowdataObj = selectedFlatRows.map(
      (d) => d.original
      // console.log('2',rowdataObj)
    );
    TripCharge = selectedFlatRows.map((item) => ({
      id: item?.original?.id,
      trpCharge: item?.original?.tripChargePower,
      timezone: item?.original?.timezone,
    }));

    rowID = selectedFlatRows.map((d) => d.original.id);
    let vehID = selectedFlatRows.map((d) => d?.original?.vehicle?.vehID);

    let vehIds = "";
    for (let i = 0; i < vehID?.length; i++) {
      if (vehID[i] !== undefined || vehID[i] !== "") {
        vehIds += vehID[i] + ",";
      }
    }

    let IdVeh = vehIds.split(/[\s,]+/).join();

    vehicleID = IdVeh.replace(/,\s*$/, "");
    let ids = "";
    for (let i = 0; i < rowID.length; i++) {
      if (rowID[i] !== undefined || rowID[i] !== "") {
        ids += rowID[i] + ",";
      }
    }

    let idswi = ids.split(/[\s,]+/).join();

    chargerId = idswi.replace(/,\s*$/, "");
    let tID = selectedFlatRows.map((d) => d?.id);
    let tableID = "";
    for (let i = 0; i < tID.length; i++) {
      if (tID[i] !== undefined) {
        tableID += tID[i] + ",";
      }
    }
    chargerTableId = tableID.replace(/,\s*$/, "");
    // if (checkPopUp !== true) {
    if (chargerTableId !== undefined && chargerTableId?.length >= 0) {
      localStorage.setItem("selectedId", chargerTableId);
      // dispatch(addFleetId(chargerTableId));
    }
  }
  // }

  // Render the UI for your table
  const firstPageRows = rows;
  return (
    <>
      <table {...getTableProps()}>
        <thead style={{ backgroundColor: "#FFFFFF", zIndex: 3 }}>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th key={i}>
                  <div className="flex-th">
                    <span
                      className={cn(styles.tableHeader)}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      title={
                        column?.id !== "selection" &&
                        column?.id !== "setChargingTime" &&
                        column?.id !== "tripSchedule"
                          ? "Sort"
                          : ""
                      }
                    >
                      <span
                        onClick={() => shortingColumn(column)}
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? "textColor"
                              : " textColor"
                            : ""
                        }
                      >
                        {column.render("Header") === "Next Trip"
                          ? "🔽"
                          : column.render("Header")}{" "}
                      </span>
                    </span>
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? downArrow
                          : upArrow
                        : ""}
                    </span>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {firstPageRows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, pos) => {
                  return (
                    <td key={pos} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* debug code point */
      /* <p>Selected Rows: {Object.keys(selectedRowIds).length}</p>
      <pre>
        <code>
          {JSON.stringify(
            {
              selectedRowIds: selectedRowIds,
              'selectedFlatRows[].original': selectedFlatRows.map(
                d => d.original
              ),
            },
            null,
            2
          )}
        </code>
      </pre> */}
    </>
  );
}

function App(props) {
  const [tripPopup, settripSchedule] = useState(false);
  const [calendarPopUp, setCalendarPopUp] = useState(false);
  const postData = {};
  const handleToggle = () => {
    settripSchedule(!tripPopup);
    setCalendarPopUp(false);
  };

  const blank = () => {};

  var tableRowData;
  const confirmSave = useCallback((data) => {
    // setConfirmData(data)
    if (data) {
      let tId = tableRowData.original.transactionId;
      postRequest("transactions/" + tId + "/instant-charge", postData)
        .then((res) => {
          if (res.status == 202) {
            console.log("CHARGER POST API success");
            // setConfirmecondPopup(false)
          } else {
            console.error("err");
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
      // })
    }
  }, []);

  const postFleetData = useCallback(async (e) => {
    tableRowData = e;
    // setConfirmecondPopup(true)
    if (e?.original?.setChargingTime?.name === "Manual Charge") {
      confirmSave(tableRowData);
    } else if (
      e?.original?.setChargingTime?.name === "Back To Scheduled" ||
      e?.original?.setChargingTime?.name === "Stop Charge"
    ) {
      deleteChargerData(tableRowData);
    }
  }, []);

  const deleteChargerData = async (e) => {
    let tId = e.original.transactionId;
    await deleteRequest("transactions/" + tId + "/instant-charge")
      .then((res) => {
        if (res.status == 202) {
          console.log("CHARGER DELETE API success");
        } else {
          console.error("err");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  let ArrayData;
  if (
    (props?.filterdatas !== undefined && props?.filterdatas?.length > 0) ||
    (props?.filterVehicleData !== undefined &&
      props?.filterVehicleData.length > 0)
  ) {
    // let siteList = JSON.parse(localStorage.getItem('filterSite'));
    // let vehicleList = JSON.parse(localStorage.getItem('filterVehicle'))
    let siteList = props?.filterdatas;
    let vehicleList = props?.filterVehicleData;
    if (props?.filterdatas?.length > 0 || props?.filterVehicleData > 0) {
      if (siteList?.length > 1 || vehicleList?.length > 1) {
        if (siteList?.length >= vehicleList?.length) {
          ArrayData = props?.fleetsData?.filter((obj) =>
            siteList?.some(
              ({ evseId, value }) =>
                obj?.site?.siteId === value || obj?.vehicle?.vehID === value
            )
          );
        } else if (vehicleList?.length >= siteList?.length) {
          ArrayData = props?.fleetsData?.filter((obj) =>
            vehicleList?.some(
              ({ evseId, value }) =>
                obj?.id === evseId || obj?.vehicle?.vehID === value
            )
          );
        } else {
          ArrayData = props?.fleetsData?.filter((obj) =>
            props?.filterdatas?.some(
              ({ evseId, value }) =>
                obj?.site?.siteId === value || obj?.vehicle?.vehID === value
            )
          );
        }
      } else {
        if (vehicleList?.length == siteList?.length) {
          ArrayData = props?.fleetsData?.filter((obj) =>
            vehicleList?.some(
              ({ evseId, value }) =>
                obj?.id === evseId || obj?.vehicle?.vehID === value
            )
          );
        } else if (siteList?.length > 0) {
          ArrayData = props?.fleetsData?.filter((obj) =>
            siteList?.some(
              ({ evseId, value }) =>
                obj?.site?.siteId === value || obj?.vehicle?.vehID === value
            )
          );
        } else if (vehicleList?.length > 0) {
          ArrayData = props?.fleetsData?.filter((obj) =>
            vehicleList?.some(
              ({ evseId, value }) =>
                obj?.id === evseId || obj?.vehicle?.vehID === value
            )
          );
        } else {
          ArrayData = props?.fleetsData?.filter((obj) =>
            props?.filterdatas?.some(
              ({ evseId, value }) =>
                obj?.id === evseId || obj?.vehicle?.vehID === value
            )
          );
        }
      }
    } else {
      if (siteList?.length > 0) {
        ArrayData = props?.fleetsData?.filter((obj) =>
          siteList?.some(
            ({ evseId, value }) =>
              obj?.site?.siteId === value || obj?.vehicle?.vehID === value
          )
        );
      } else if (vehicleList?.length > 0) {
        ArrayData = props?.fleetsData?.filter((obj) =>
          vehicleList?.some(
            ({ evseId, value }) =>
              obj?.id === value || obj?.vehicle?.vehID === value
          )
        );
      } else {
        ArrayData = props?.fleetsData;
      }
    }

    // if(props.filterdatas.length>0){
    // // ArrayData = props?.fleetsData.filter(obj => props?.filterdatas.some(({label}) =>obj?.site.replaceAll(" ", "") === label.replaceAll(" ", "") ||(obj.vehicle.name).replaceAll(" ", "")===(label).replaceAll(" ", "")));
    // ArrayData = props?.fleetsData.filter(obj => props?.filterdatas.some(({ evseId, value }) => obj?.id === evseId || (obj?.vehicle?.vehID) === (value)));
    // }
    // else{
    //   ArrayData=props?.fleetsData;
    // }
  } else {
    if (props?.alertState) {
      ArrayData = props?.fleetsData.filter(
        (item) =>
          item?.status.type.toLocaleLowerCase() === "alert" ||
          item?.nextTrip.error === true
      );
    } else if (props?.chargingState) {
      ArrayData = props?.fleetsData.filter(
        (item) => item?.status.type.toLocaleLowerCase() === "charging"
      );
    } else if (props?.dischargingState) {
      ArrayData = props?.fleetsData.filter(
        (item) => item?.status.type.toLocaleLowerCase() === "discharging"
      );
    } else {
      ArrayData = props?.fleetsData;
    }
  }
  useEffect(() => {
    props.selectedRecordCb(ArrayData);
  }, [ArrayData]);

  function capitalize(input) {
    return input
      .toLowerCase()
      .split(" ")
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(" ");
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "Vehicle ",
        accessor: "vehicle.name",
        Cell: (props) => {
          return (
            <>
              {" "}
              <div className={cn(styles.vehicle, styles.vehicle_layout)}>
                <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                  {props?.value}
                </h5>
                <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                  {props?.cell?.row?.original?.vehicle?.model}
                </h5>
              </div>
            </>
          );
        },
      },
      {
        Header: "Status ",
        // disableSortBy: false,
        accessor: "status.type",
        Cell: (props) => {
          // console.log(props)
          return (
            <>
              {" "}
              <div className={cn(styles.col_status, styles.col_status_layout)}>
                {props?.cell?.row?.original?.status?.error1 !== "" ? (
                  <img
                    src={
                      require("assets/" +
                        props?.cell?.row?.original?.status?.error1 +
                        ".svg").default
                    }
                    alt="Rectangle 12"
                    className={cn(
                      styles.col_status_box,
                      props?.cell?.row?.original?.status?.error1,
                      styles.col_status_box_layout
                    )}
                  />
                ) : (
                  ""
                )}
                <h5
                  className={cn(
                    styles.h5_prop3,
                    styles.h5_prop3_layout,
                    props.value !== "" ? props.value : "Unplugged",
                    styles.blackColor
                  )}
                >
                  {props.value === "EV_EVSE_ERROR" ||
                  props.value === "EVSE_ERROR" ||
                  props.value === "EV_ERROR"
                    ? "Error"
                    : props.value === "DOWN"
                    ? "Disconnected"
                    : props.value === "UP"
                    ? "Connected"
                    : props.value === ""
                    ? "Unplugged"
                    : capitalize(props.value)}
                </h5>
              </div>
            </>
          );
        },
      },
      {
        Header: "Charger ",
        // disableSortBy: false,
        accessor: "charger.name",
        Cell: (props) => {
          return (
            <>
              <div
                className={cn(styles.col_charger, styles.col_charger_layout)}
              >
                <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                  {props?.value}
                  {props?.value?.isIcon === true ? (
                    <img
                      src={require("assets/ic_insert_link_48px.svg").default}
                      className={cn(styles.chargericon)}
                    />
                  ) : (
                    ""
                  )}
                </h5>
                <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                  {props?.cell?.row?.original?.charger?.port}
                </h5>
              </div>
            </>
          );
        },
      },
      {
        Header: "SoC ",
        accessor: "soc.current",
        Cell: (props) => {
          return (
            <>
              {props?.cell?.row?.original?.soc?.current === "" ||
              props?.cell?.row?.original?.soc?.current === undefined ? (
                ""
              ) : (
                <>
                  <div className={cn(styles.col_soc, styles.col_soc_layout)}>
                    {props?.cell?.row?.original?.soc?.current !== "" &&
                    props?.cell?.row?.original?.vehicle?.name !== undefined ? (
                      <div
                        className={cn(
                          styles.col_soc_flex,
                          styles.col_soc_flex_layout
                        )}
                      >
                        <div className={cn(styles.col_soc_flex_item)}>
                          <BatteryProgress
                            className={cn(styles.box20, styles.box20_layout)}
                            bgcolor={props?.cell?.row?.original?.soc?.color}
                            progress={props.value}
                            height="22"
                            targetVal={props?.cell?.row?.original?.soc?.target}
                          ></BatteryProgress>
                        </div>
                        <div className={cn(styles.col_soc_flex_spacer)} />
                        <h5
                          className={cn(
                            styles.highlights,
                            styles.highlights_layout
                          )}
                        >
                          {props?.value}%
                        </h5>
                      </div>
                    ) : (
                      ""
                    )}
                    {(props?.cell?.row?.original?.vehicle?.name !== undefined &&
                      (props?.cell?.row?.original?.soc?.current === "" ||
                        props?.cell?.row?.original?.soc?.current ===
                          undefined ||
                        props?.cell?.row?.original?.soc?.target === "" ||
                        props?.cell?.row?.original?.soc?.target ===
                          undefined)) ||
                    props?.cell?.row?.original?.vehicle?.name === undefined ? (
                      ""
                    ) : (
                      <h5
                        className={cn(styles.h5_target, styles.h5_prop_layout)}
                      >
                        {props?.cell?.row?.original?.soc?.target !== ""
                          ? "Target"
                          : ""}{" "}
                        {props?.cell?.row?.original?.soc?.target !== ""
                          ? ":"
                          : ""}{" "}
                        {props?.cell?.row?.original?.soc?.target}{" "}
                        {props?.cell?.row?.original?.soc?.target !== ""
                          ? "%"
                          : ""}
                      </h5>
                    )}
                  </div>
                </>
              )}
            </>
          );
        },
      },
      {
        Header: "Site ",
        accessor: "site.street",
        Cell: (props) => {
          return (
            <>
              {props.value !== undefined &&
              props?.cell?.row?.original?.site?.region !== undefined &&
              props?.cell?.row?.original?.site?.countryCode ? (
                <div
                  className={cn(styles.col_charger, styles.col_charger_layout)}
                >
                  <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                    {props?.value}
                  </h5>
                  <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                    {props?.cell?.row?.original?.site?.region +
                      ", " +
                      props?.cell?.row?.original?.site?.countryCode}
                  </h5>
                </div>
              ) : (
                ""
              )}
            </>
          );
        },
      },
      {
        Header: "Ready By ",
        accessor: "readyBy",
        Cell: (props) => {
          return (
            <>
              {" "}
              <div
                className={cn(
                  styles.col_next_trip,
                  styles.col_next_trip_fleet_layout
                )}
              >
                <div
                  className={cn(styles.col_next_trip_item, styles.col_width_50)}
                >
                  <div
                    className={cn(
                      styles.col_next_trip,
                      styles.col_next_trip_fleet_layout
                    )}
                  >
                    <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                      {props?.value}
                    </h5>
                  </div>
                </div>
                <div className={cn(styles.col_next_trip_spacer)} />
                <div
                  className={cn(
                    styles.col_next_trip_item1,
                    styles.col_ime_next_trip
                  )}
                >
                  {/* {props.value.error? <img src={
                      require('assets/ic_report.svg')
                        .default
                    } alt="Rectangle 14" className={cn(styles.col_next_trip_box, styles.col_next_trip_box_layout)}/> : <div/>} */}
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "Next Trip ",
        accessor: "nextTrip.date",
        Cell: (props) => {
          return (
            <>
              {" "}
              <div
                className={cn(
                  styles.col_next_trip,
                  styles.col_next_trip_fleet_layout
                )}
              >
                <div
                  className={cn(styles.col_next_trip_item, styles.col_width_50)}
                >
                  <div
                    className={cn(
                      styles.col_next_trip,
                      styles.col_next_trip_fleet_layout
                    )}
                  >
                    {(props?.cell?.row?.original?.vehicle !== undefined &&
                      props?.cell?.row?.original?.soc?.target === undefined &&
                      props?.cell?.row?.original?.soc?.target === "") ||
                    props?.cell?.row?.original?.vehicle?.name === undefined ||
                    props?.cell?.row?.original?.soc?.target === undefined ? (
                      ""
                    ) : (
                      <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                        {props?.value}
                      </h5>
                    )}
                  </div>
                </div>
                <div className={cn(styles.col_next_trip_spacer)} />
                {(props?.cell?.row?.original?.vehicle !== undefined &&
                  props?.cell?.row?.original?.soc?.target === undefined &&
                  props?.cell?.row?.original?.soc?.target === "") ||
                props?.cell?.row?.original?.vehicle?.name === undefined ||
                props?.cell?.row?.original?.soc?.target === undefined ? (
                  ""
                ) : (
                  <div
                    className={cn(
                      styles.col_next_trip_item1,
                      styles.col_ime_next_tripFleet
                    )}
                  >
                    {props?.row?.original?.nextTrip?.error ? (
                      <img
                        src={require("assets/ic_report.svg").default}
                        alt="Rectangle 14"
                        className={cn(
                          styles.col_next_trip_box,
                          styles.col_next_trip_box_layout
                        )}
                      />
                    ) : (
                      <div />
                    )}
                  </div>
                )}
              </div>
            </>
          );
        },
      },
      {
        Header: "Trip Schedule",
        accessor: "tripSchedule",
        disableSortBy: true,
        Cell: (props) => {
          return (
            <>
              {" "}
              <div className={cn(styles.col_status, styles.col_status_layout)}>
                <img
                  src={require("assets/ic_event_note_48px.svg").default}
                  onClick={(e) => openCalendar(props.row)}
                  alt="Rectangle 12"
                  className={cn(
                    styles.col_status_box,
                    styles.col_status_box_layout2
                  )}
                />
              </div>
            </>
          );
        },
      },
      {
        // Header: 'VIN# ↓↑',
        Header: () => <div style={{ textAlign: "center" }}>VIN </div>,
        accessor: "VIN",
        Cell: (props) => {
          return (
            <>
              <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                {props?.value}
              </h5>
            </>
          );
        },
      },
      {
        Header: () => {
          return (
            <>
              <div
                className={cn(
                  styles.group,
                  styles.group_layout,
                  checkCount > 0
                    ? styles.set_charge_time_active_fleet
                    : styles.set_charge_time_fleet
                )}
                onClick={checkCount > 0 ? handleToggle : blank}
              >
                <h5
                  style={{
                    color: "#ffffff",
                    padding: "5px 5px",
                    font: "normal normal 700 10px/13px Montserrat",
                  }}
                  className={cn(
                    styles.small_text_body,
                    styles.small_text_body_layout
                  )}
                >
                  {<span>{"TRIP SCHEDULES"}</span>}
                  {localStorage.setItem("TripSechedule", "Trip Schedule")}
                </h5>
              </div>
            </>
          );
        },
        disableSortBy: true,
        accessor: "setChargingTime",
        Cell: (props) => {
          return (
            <>
              {" "}
              <div
                style={{ background: props.value.color }}
                className={cn(styles.group, styles.group_layout)}
                onClick={(e) => postFleetData(props.row)}
              >
                {props.value.name !== undefined &&
                props.value.name !== "" &&
                props?.row?.original?.statusName != "alert" &&
                props?.row?.original?.statusName != "down" &&
                props?.row?.original?.statusName != "" &&
                props?.row?.original?.nextTrip?.error != true ? (
                  <h5 className={cn(styles.h5_prop2, styles.h5_prop2_layout2)}>
                    {props?.value?.name}
                  </h5>
                ) : (
                  ""
                )}
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const toggleSelected = (data) => {
    const a = data;
    // console.log("===",a)
  };

  const openCalendar = (evt) => {
    var idRow = localStorage.getItem("selectedId");
    localStorage.setItem("selectedRowId", idRow);
    rowdataObj = [];
    chargerId = "";
    setCalendarPopUp(true);
    toggleSelected();
    localStorage.setItem("selectedId", "");
    if (rowdataObj?.length <= 1) {
      settripSchedule(true);
      if (rowdataObj?.length === 0) {
        // debugger
        rowdataObj?.push(evt?.original);
        localStorage.setItem("rowItems", JSON.stringify(evt?.original));
        localStorage.setItem("idVehicle", evt?.original?.vehicle?.vehID);
        chargerId = localStorage.getItem("idVehicle");
        TripCharge = [
          {
            id: evt?.original?.id,
            trpCharge: "",
            timezone: evt?.original?.timezone,
          },
        ];
      } else {
        if (rowdataObj?.includes(evt?.original)) {
          setCalendarPopUp(true);
          rowdataObj?.push(evt.original);
          localStorage.setItem("rowItems", JSON.stringify(evt?.original));
          localStorage.setItem("idVehicle", evt?.original?.vehicle?.vehID);
          chargerId = localStorage.getItem("idVehicle");
          // TripCharge = {
          //   id: evt?.original?.id,
          //   trpCharge: evt?.original?.tripChargePower,
          //   timezone: evt?.original?.vehicle?.vehID.timezone
          // }
        }
      }
    }
  };
  if (rowdataObj?.length <= 0) {
    rowdataObj = [JSON.parse(localStorage.getItem("rowItems"))];
    // console.log(rowdataObj)
  }

  if (chargerId === undefined || chargerId === "") {
    chargerId = localStorage.getItem("idVehicle");
  }
  useEffect(() => {
    localStorage.setItem("selectedId", "");
    localStorage.setItem("checkedId", "");
  }, []);
  return (
    <Styles>
      <Table
        columns={columns}
        data={ArrayData}
        checkPopUp={calendarPopUp}
        toggleInput={toggleSelected}
      />

      {tripPopup === true ? (
        <TripAndCharge
          popupState={handleToggle}
          tripChargeSchedule={TripCharge}
          rowData={rowdataObj}
          charId={chargerId}
        />
      ) : (
        ""
      )}
    </Styles>
  );
}

export default App;
